import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "flex flex-row gap-2" }
const _hoisted_3 = { class: "flex flex-row gap-2" }
const _hoisted_4 = { class: "flex-2" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "flex flex-row gap-2" }
const _hoisted_7 = { class: "flex flex-row gap-2" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { toast } from "@/common/utils/toast";

import { maskCEP } from "@/common/utils/mask";

import { baseInput, baseSelect } from "@/common/components";

import { searchByCep } from "@/common/api/rest/address";

import type { AddressType } from "@/common/types/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'address',
  props: {
    data: {},
    title: {},
    width: { default: "100%" }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const defaultData = {
  is_main: false,
  name: "",
  address: "",
  number: "",
  complement: "",
  district: "",
  city: "",
  state: "",
  country: "Brasil",
  cep: "",
};

const payload = ref<AddressType>({ ...defaultData });

const countryOptions = computed(() => [{ option: "Brasil", value: "Brasil" }]);

function update() {
  emit("update-data", payload.value);
}

function searchCep() {
  searchByCep(payload.value.cep)
    .then((response) => {
      if (!response) {
        toast({ message: t("error.default"), type: "error" });
        return;
      }
      const { bairro, localidade, logradouro, uf } = response;

      payload.value = {
        ...payload.value,
        address: logradouro,
        state: uf,
        district: bairro,
        city: localidade,
      };
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function cepMask(value: string) {
  if (payload.value.country === "Brasil") return maskCEP(value);

  return value;
}

watchEffect(() => {
  if (props.data) {
    payload.value = { ...props.data };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-content",
    style: _normalizeStyle({ width: __props.width })
  }, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", null, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " * ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(baseSelect), {
          modelValue: payload.value.country,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.country) = $event)),
          value: payload.value.country,
          options: countryOptions.value,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.country")) + " * ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"]),
        _createVNode(_unref(baseInput), {
          modelValue: payload.value.cep,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.cep) = $event)),
          value: payload.value.cep,
          mask: cepMask,
          onInput: _cache[5] || (_cache[5] = ($event: any) => (update())),
          onBlur: _cache[6] || (_cache[6] = ($event: any) => (searchCep()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.cep")) + " * ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(baseInput), {
            modelValue: payload.value.address,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((payload.value.address) = $event)),
            value: payload.value.address,
            onInput: _cache[8] || (_cache[8] = ($event: any) => (update()))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.address")) + " * ", 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(baseInput), {
            modelValue: payload.value.number,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((payload.value.number) = $event)),
            value: payload.value.number,
            onInput: _cache[10] || (_cache[10] = ($event: any) => (update()))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.number")) + " * ", 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(baseInput), {
          modelValue: payload.value.complement,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((payload.value.complement) = $event)),
          value: payload.value.complement,
          onInput: _cache[12] || (_cache[12] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.complement")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"]),
        _createVNode(_unref(baseInput), {
          modelValue: payload.value.district,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((payload.value.district) = $event)),
          value: payload.value.district,
          onInput: _cache[14] || (_cache[14] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.district")) + " * ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(baseInput), {
          modelValue: payload.value.city,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((payload.value.city) = $event)),
          value: payload.value.city,
          onInput: _cache[16] || (_cache[16] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.city")) + " * ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"]),
        _createVNode(_unref(baseInput), {
          modelValue: payload.value.state,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((payload.value.state) = $event)),
          value: payload.value.state,
          onInput: _cache[18] || (_cache[18] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.state")) + " * ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"])
      ])
    ])
  ], 4))
}
}

})